if (!customElements.get('ly-format-time')) {
    customElements.define('ly-format-time', class extends HTMLElement {
        static get observedAttributes() {
            return ['data-time']
        }

        attributeChangedCallback(name, oldValue, newValue) {
            if (name === 'data-time') {
                this.render()
            }
        }

        formatter = new Intl.DateTimeFormat('en-US', {
            month: 'short'
        })

        connectedCallback() {
            this.render()
        }

        render = () => {
            const time = this.dataset.time
            if (!time) {
                this.textContent = ''
                return
            }

            const [year, month, day] = time.split('-').map(Number)
            const date = new Date(year, month - 1, day)
            this.textContent = this.formatter.format(date) + (this.dataset.flag || '')
        }
    })
}